<template lang="pug">
  b-form.gl-autocomplete(novalidate)
    // input
    b-form-group(:label-for="inputId" :label="options.label" :state="options.state" flex)
      .gl-autocomplete__container(:id="containerId" v-gl-on-click-away="closePopover")
        .al-autocomplete__target(:id="targetId" @click="popoverIsOpen = true")
          b-form-input.gl-autocomplete__input(@input="inputChange" v-model="query" :id="inputId" :placeholder="options.placeholder" :state="options.state" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
      font-awesome-icon.gl-autocomplete__icon(:class="{ 'feedback-padding': options.invalidFeedback }" icon="search")
      .invalid-feedback.display-block(v-if="options.invalidFeedback") {{ options.invalidFeedback }}

    // popover
    b-popover.gl-autocomplete__popover(:target="targetId" :show.sync="popoverIsOpen" :container="containerId" placement="top")
      .gl-autocomplete__popover__head
        .gl-autocomplete__popover__head__title {{ options.title || 'Select a group' }}
        button.close(@click="closePopover" type="button") &times;
      .gl-autocomplete__popover__body(v-if="filteredList")
        .gl-autocomplete__popover__item(@click="itemClicked(item)" v-if="filteredList.length" v-for="item in filteredList" :key="item.$key" :class="{ 'pending': disablePending && item.status === 'Pending' }" href="javascript:void(0)")
          span {{ item.name }}
          b-badge.ml-8(v-if="item.isActive === false") Inactive
          b-badge.ml-8(v-if="item.status === 'Pending'") Pending
        .gl-autocomplete__popover__404(v-if="!options.listLoading && !filteredList.length") No results found
        .gl-autocomplete__popover__loading(v-if="options.listLoading && !filteredList.length" layout="row" layout-align="center center")
          pulse-loader(:loading="true" :color="'#8EA2AC'" :size="'10px'")
          .gl-autocomplete__popover__loading__label Loading

</template>

<script>
import _ from 'lodash'

export default {

  // props
  props: {
    list: Array,
    options: Object,
    disablePending: Boolean
  },

  // on mount
  mounted () {
    // if listLoading is undefined -> default it to false
    if (_.isUndefined(this.options.listLoading)) {
      this.options.listLoading = false
    }
  },

  // data
  data () {
    return {
      query: '',
      popoverIsOpen: false
    }
  },

  // computed
  computed: {
    containerId () {
      return 'gl-autocomplete--container--' + _.random(0, 1000000)
    },
    targetId () {
      return 'gl-autocomplete--target--' + _.random(0, 1000000)
    },
    inputId () {
      return 'gl-autocomplete--input--' + _.random(0, 1000000)
    },
    filteredList () {
      // add $key to each item in the list (for v-for)
      let keyList = _.map(this.list, (item) => {
        return { ...item, $key: _.uniqueId('item-') }
      })

      // if query -> return list filtered by name
      // else -> return all items in list
      if (this.query && this.query.length) {
        return _.filter(keyList, (item) => {
          return _.includes(item.name.toLowerCase(), this.query.toLowerCase())
        })
      } else {
        return this.list
      }
    }
  },

  // methods
  methods: {
    closePopover () {
      // close popover
      this.popoverIsOpen = false
    },
    itemClicked (item) {
      if (this.disablePending && item.status === 'Pending') {
        // do not $emit
      } else {
        // close popover
        this.closePopover()

        // emit event
        this.$emit('item-clicked', item)
      }
    },
    inputChange () {
      // if query -> show popover
      if (this.query && this.query.length > 0) {
        this.popoverIsOpen = true
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../styles/colors';
  @import '../styles/variables';

  .gl-autocomplete {
    position: relative;
    $inputHeight: 38px;

    .popover {
      border-radius: 5px;
      border-color: $gl-grey-border;
      &.bs-popover-bottom {
        top: $inputHeight !important;
        transform: none !important;

        .arrow {
          &:after {
             border-bottom-color: $gl-white-smoke;
          }
        }
      }

      .popover-body {
        padding: 0;
        border-radius: 5px;
      }
    }

    &__container, &__target {
      position: relative;
      width: 100%;
    }

    &__popover {
      border-radius: 5px;

      &__head {
        position: relative;
        background-color: $gl-white-smoke;
        padding: 10px 10px 10px $gl-gutter;
        border-bottom: 1px solid $gl-grey-border;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;

        &__title {
          font-size: 15px;
          font-weight: 700;
          margin-right: 10px;
          color: $gl-grey-darker;
        }

        .close {
          transform: translateY(1px);
          position: absolute;
          right: 1rem;
          top: 7px;
          float: none;
        }
      }

      &__body {
        overflow-y: auto;
        max-height: 210px;
      }

      &__item, &__404, &__loading {
        padding: 8px $gl-gutter;
        min-width: 150px;
        min-width: 200px;
        font-size: 15px;
      }

      &__item, &__404 {
        color: $gl-grey-darker;
      }

      &__loading {

        &__label {
          color: $gl-grey;
          margin-left: 8px;
          transform: translateY(-2px);
        }
      }

      &__item {
        cursor: pointer;
        &:hover {
          background: $gl-grey-hover;
        }
        &.pending {
          opacity: 0.5;
          cursor: default;
        }
      }
    }

    &__input {
      padding-left: 36px;
      height: $inputHeight;
    }

    &__icon {
      position: absolute;
      left: 12px;
      bottom: 12px;
      &.feedback-padding {
        bottom: 26px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-autocomplete.vue